import React from "react";
import { $t } from '@/modules/i18n';

const Prizes = ({ message = {}, className }) => (
  <section id="prizes" className={className}>
    <h2 className="section-title">{ $t(message.title) }</h2>
    <p className="desc">{$t(message.desc)}</p>
  </section>
);

export default Prizes;
